import { useMediaMatch } from "rooks";
import { DefaultTheme, useTheme } from "styled-components";

export default function useBreakpointMatch(breakpoint: keyof DefaultTheme["breakpoints"]) {

    const theme = useTheme();
    return !!useMediaMatch(theme.breakpoints[breakpoint]);
}